// 2_components/breadcrumbs.js
// Marks the .breadcrumbs trail as "only-home" (<=2 crumbs) or "shortened" so CSS
// can collapse the middle crumbs.

export function init() {
	const breadcrumbs = document.querySelector(".breadcrumbs");
	if (!breadcrumbs) return;

	const breadcrumbsSpans = Array.from(breadcrumbs.querySelectorAll("span[itemprop='itemListElement']"));
	if (breadcrumbsSpans.length <= 2) {
		breadcrumbs.classList.add("only-home");
	} else {
		breadcrumbs.classList.add("shortened");
	}
}
